import { h } from 'preact'
import { useAppState } from 'lib/appState'

export function useDeleteOrganization(organizationApikey, componentName){
  const {
    appAction,
    deletingOrganization,
    deletingOrganizationError,
  } = useAppState(
    {
      [`organization:${organizationApikey}:deleting`]: 'deletingOrganization',
      [`organization:${organizationApikey}:deleting:error`]: 'deletingOrganizationError',
    },
    componentName,
  )
  const deleteOrganization = appAction('superAdmin.deleteOrganization', organizationApikey)

  return {
    deleteOrganization,
    deletingOrganization,
    deletingOrganizationError,
  }
}
